import axios from 'axios';

const baseUrl = '/ssp/api/';
//const baseUrl = 'https://dev.intermediaries.hsbc.co.uk/ssp/api/';

if (!baseUrl) {
  throw new Error('Missing environment variables for API config.');
}

const apiClientCreate = axios.create({
  baseURL: baseUrl,
});

const request = async (method, endpoint, data, config = {}) => {
  const headers = {};

  if (!(data instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const { headers: customHeaders, ...restConfig } = config;

  return new Promise((resolve, reject) => {
    apiClientCreate({
      method,
      url: endpoint,
      data,
      headers: { ...headers, ...customHeaders },
      ...restConfig,
    })
      .then(({ data }) => resolve(data))
      .catch((error) => {
        if (error.response) reject(error.response);
        else if (error.request) reject(new Error('No response received from server'));
        else reject(new Error(`Request Setup Error: ${error.message}`));
      });
  });
};

export const apiClient = {
  get: (endpoint, config) => request('GET', endpoint, undefined, config),
  post: (endpoint, body, config) => request('POST', endpoint, body, config),
  put: (endpoint, body, config) => request('PUT', endpoint, body, config),
  patch: (endpoint, body, config) => request('PATCH', endpoint, body, config),
  delete: (endpoint, config) => request('DELETE', endpoint, undefined, config),
};
